import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0811 5.919c-3.3585-3.3586-8.8037-3.3586-12.1622 0-3.3585 3.3584-3.3585 8.8036 0 12.1621 3.3585 3.3585 8.8037 3.3585 12.1622 0 3.3585-3.3585 3.3585-8.8037 0-12.1622ZM4.5047 4.5046C8.6442.365 15.3558.365 19.4954 4.5047c4.1395 4.1395 4.1395 10.8511 0 14.9907-4.1396 4.1395-10.8512 4.1395-14.9907 0C.365 15.3558.365 8.6442 4.5047 4.5047Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.9891 12.6402 3.5356 4.2427c.3535.4243.9841.4816 1.4084.128.4242-.3535.4816-.9841.128-1.4084l-2.1687-2.6024h6.3503c.5522 0 1-.4478 1-1 0-.5523-.4478-1-1-1H9.8923l2.1688-2.6025c.3536-.4243.2962-1.0549-.128-1.4084-.4243-.3536-1.0549-.2963-1.4084.128l-3.5356 4.2427a.9999.9999 0 0 0 0 1.2803Z"
    />
  </>,
  'ArrowLeftContained2'
)
